// extracted by mini-css-extract-plugin
export var externalLink = "_c4-0";
export var internalLinkLabel = "_c4-1";